export default function Footer() {
  return (
    <footer className=" text-center py-3 mt-4">
    </footer>
  );
}
